import React from 'react'
import { Link, type To } from 'react-router-dom'

import theme from 'theme'

export const LowerLink: React.FC<{
  to: To
}> = ({ to, children, ...rest }) => {
  return (
    <section
      css={{
        fontSize: theme.fontSizes[2],
        textAlign: 'center',
        marginTop: theme.space[3]
      }}
    >
      <Link css={{ color: theme.colors.steel[1] }} to={to} {...rest}>
        {children}
      </Link>
    </section>
  )
}
